import { useState } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import { usePageMeta } from '@/hooks/usePageMeta'

const WINE = '#3a1228'
const WINE_DEEP = '#1c0b14'
const WINE_SOFT = '#5c1a3a'
const CREAM = '#f4eee4'
const CREAM_SOFT = '#ebe3d6'
const INK_DARK = '#2c1a22'
const INK_MUTED = '#5a4450'
const LILAC = '#B9A3D9'
const PHOTO_SRC = 'https://static.lumi.new/66/66a59164029fe3389411bfef927c8644.webp'
const WA_LINK = 'https://wa.me/5581988671210'

const SILVIA_AFTER = [
  {
    src: 'https://static.lumi.new/fa/fa5fde5cf679319f2466cf15af8193d8.webp',
    alt: 'Relato de Sílvia no WhatsApp após os 3 atendimentos da Cura Quântica Frequencial — silvia-1',
  },
  {
    src: 'https://static.lumi.new/2d/2d45f65dd7b21233e9b7cd99963ed058.webp',
    alt: 'Relato de Sílvia no WhatsApp após os 3 atendimentos da Cura Quântica Frequencial — silvia-2',
  },
  {
    src: 'https://static.lumi.new/bf/bfc3ab1457648991ceefa1b762ee8e84.webp',
    alt: 'Relato de Sílvia no WhatsApp após os 3 atendimentos da Cura Quântica Frequencial — silvia-3',
  },
]

const SILVIA_20_DAYS = [
  {
    src: 'https://static.lumi.new/5a/5afbd488cf0addb5bd65173d7ea8c0ee.webp',
    alt: 'Relato de Sílvia no WhatsApp 20 dias após os 3 atendimentos da Cura Quântica Frequencial — silvia-4',
  },
  {
    src: 'https://static.lumi.new/bf/bf359d3079aa20e3ef3d52a1892a6a4c.webp',
    alt: 'Relato de Sílvia no WhatsApp 20 dias após os 3 atendimentos da Cura Quântica Frequencial — silvia-5',
  },
]

const OTHER_REPORTS = [
  {
    src: 'https://static.lumi.new/bc/bceffa2b58fb7f1e0de110a3b5c84483.webp',
    alt: 'Relato de Neide Barros no WhatsApp sobre atendimento à distância da Cura Quântica Frequencial',
  },
  {
    src: 'https://static.lumi.new/d0/d016f647e14515191d73a02dfbe88526.webp',
    alt: 'Relato de Edna no WhatsApp sobre atendimento à distância da Cura Quântica Frequencial',
  },
  {
    src: 'https://static.lumi.new/fb/fb3fb7d58d8442f03da3d37588a28c7f.webp',
    alt: 'Relato de Vanessa no WhatsApp sobre atendimento à distância da Cura Quântica Frequencial',
  },
  {
    src: 'https://static.lumi.new/67/67b85dcc0c915de121c59ed2d2acf5ef.webp',
    alt: 'Relato de Carla no WhatsApp sobre atendimento à distância da Cura Quântica Frequencial',
  },
]

const FOR_WHOM = [
  'Para quem vive conflitos internos, ciclos repetitivos e está com bloqueios de prosperidade ou nos relacionamentos;',
  'Para quem se sente perdido, sem propósito e busca um novo sentido para a vida;',
  'Para quem tem estresse, ansiedade, depressão, dores crônicas, doenças diagnosticadas ou qualquer desconforto na saúde mental, emocional ou física;',
  'Para quem deseja se conectar com sua verdadeira essência e expandir a consciência;',
  'Para quem deseja complementar tratamentos e busca um bem-estar integral;',
]

const ABOUT_CARDS = [
  {
    title: 'Objetivo',
    text: 'Nos colocar em contato com a nossa essência a partir da nova Frequência Inteligente do Universo.',
  },
  {
    title: 'Benefícios',
    text: 'Acessar um amplo espectro de frequências que são capazes de restabelecer o seu equilíbrio promovendo a cura em diversos níveis.',
  },
  {
    title: 'Filosofia do trabalho',
    text: 'Não é uma terapia, não é uma técnica, não é um tratamento terapêutico e não é comparável a nenhuma técnica energética.',
  },
  {
    title: 'Como acontece',
    text: 'Restabelece a conexão do indivíduo à sua fonte primordial de energia vital permitindo equilibrar e harmonizar níveis de vibração e frequências para a cura.',
  },
]

const ABOUT_EXTRA = [
  {
    title: 'Duração',
    text: 'Um atendimento à distância tem duração de 36 minutos e a pessoa fica deitada com postura receptiva no horário agendado.',
  },
  {
    title: 'Atendimento',
    text: 'Recomendamos a experiência completa de três atendimentos em dias consecutivos ou alternados.',
  },
]

const FAQ_ITEMS = [
  {
    q: 'Como a Cura Quântica Frequencial difere das abordagens tradicionais de cura e por que eu deveria considerá-la?',
    a: 'A Cura Quântica Frequencial é uma ferramenta nova e atualizada que além de ter seus próprios benefícios, inclui em suas frequências outros sistemas de energia de cura atualmente existentes no planeta. As frequências acessadas através da Cura Quântica Frequencial são mais elevadas, sem fragmentos de cores, ou seja, são caracterizadas pela luz branca pura, diferenciando-se do Reiki, Cura Prânica, Jorei e de outros tipos de energia de cura.',
  },
  {
    q: 'Como a Cura Quântica Frequencial age?',
    a: 'O que se faz na Cura Quântica Frequencial é compartilhar uma transmissão de energia, luz e informação. O facilitador vai acessar e sintonizar essas frequências e colocar o seu cliente em contato com elas, atuando como um catalizador e um acelerador do processo de cura que é do outro, sem direcionar e nem interferir no processo.',
  },
  {
    q: 'Como a Cura Quântica Frequencial aborda aspectos emocionais e mentais, além de questões físicas?',
    a: 'A Cura Quântica Frequencial, ao interagir com o campo vibratório humano, modifica a informação de luz presente em nosso DNA. Ela harmoniza o equilíbrio do nosso campo vibracional em todos os níveis: físico, emocional, mental e espiritual, incluindo camadas desconhecidas. Este contato desencadeia nosso potencial intrínseco de autocura, inaugurando um percurso de cura pessoal. Pequenas mudanças nesse processo desencadeiam infinitas possibilidades de cura, transcendendo o plano físico.',
  },
  {
    q: 'Por que fazer 3 atendimentos da Cura Quântica Frequencial?',
    a: 'Em um único atendimento, ou mesmo uma parte dele, pode ser o suficiente para você receber o que for apropriado no momento de sua vida. Eventualmente, você pode repetir atendimentos em diferentes momentos ao longo da vida. No entanto, com base na prática profissional, notamos que um processo diferenciado acontece ao realizar os três atendimentos.',
  },
  {
    q: 'Por quanto tempo a Cura Quântica Frequencial vai ficar trazendo mudanças para minha vida?',
    a: 'O processo de mudança que a Cura Quântica Frequencial proporciona começa com o primeiro atendimento e não tem prazo de validade. Uma vez iniciado, ele se torna parte contínua e expansiva da sua vida, amplificando-se diariamente.',
  },
  {
    q: 'Qual é a base científica por trás da Cura Quântica Frequencial? Há evidências de sua eficácia?',
    a: 'Está fundamentada nas mais recentes teorias e estudos da física quântica e nuclear.',
  },
  {
    q: 'Posso encomendar a Cura Quântica Frequencial para outra pessoa?',
    a: 'Sim, a pessoa pode estar ciente ou não.',
  },
  {
    q: 'Posso fazer a Cura Quântica Frequencial em animais?',
    a: 'Sim, inclusive plantas também.',
  },
]

function PrintCard({ src, alt }: { src: string; alt: string }) {
  return (
    <div
      className="overflow-hidden rounded-2xl"
      style={{
        background: '#ffffff',
        border: '1px solid rgba(58,18,40,0.08)',
        boxShadow: '0 10px 28px rgba(28,11,20,0.12)',
      }}
    >
      <img src={src} alt={alt} loading="lazy" className="block w-full h-auto" />
    </div>
  )
}

function CheckIcon() {
  return (
    <span
      className="mt-1.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full"
      style={{ background: 'rgba(255,255,255,0.12)', border: '1px solid rgba(255,255,255,0.28)' }}
      aria-hidden="true"
    >
      <svg viewBox="0 0 24 24" className="h-3.5 w-3.5" fill="none" stroke="#ffffff" strokeWidth="2.4">
        <path d="M5 12.5l4.2 4.2L19 7.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </span>
  )
}

export default function PageCuraQuantica() {
  const [openFaq, setOpenFaq] = useState<number | null>(null)

  usePageMeta({
    title: 'Cura Quântica Frequencial — Reacenda Luz',
    description: 'Acesse a nova frequência inteligente do universo e dance a música da sua vida. Atendimento à distância com Mônica Maria.',
    ogImage: PHOTO_SRC,
    ogUrl: 'https://jornada.reacendaluz.com.br/curaquantica/',
  })

  return (
    <div className="min-h-screen w-full font-body" style={{ background: WINE_DEEP, color: '#f7efe8' }}>
      <header
        className="w-full px-4 py-5 flex items-center justify-center border-b"
        style={{
          background: WINE_DEEP,
          borderColor: 'rgba(255,255,255,0.08)',
        }}
      >
        <p className="text-[11px] tracking-[0.35em] uppercase font-body opacity-70" style={{ color: LILAC }}>
          Reacenda Luz · Mônica Maria
        </p>
      </header>

      <section
        className="relative overflow-hidden px-4 sm:px-6 py-16 md:py-24"
        style={{
          background: `linear-gradient(180deg, ${WINE_DEEP} 0%, ${WINE} 48%, ${WINE_SOFT} 100%)`,
        }}
      >
        <div
          className="pointer-events-none absolute -top-24 left-1/2 h-72 w-72 -translate-x-1/2 rounded-full"
          style={{ background: 'radial-gradient(closest-side, rgba(185,163,217,0.22), transparent 72%)' }}
        />
        <div className="relative mx-auto max-w-3xl text-center">
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.7 }}
            className="mb-5 text-[10px] tracking-[0.4em] uppercase font-body"
            style={{ color: LILAC }}
          >
            Cura Quântica Frequencial
          </motion.p>
          <motion.h1
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.1 }}
            className="font-display type-hero mb-6 text-white"
          >
            Acesse a nova frequência inteligente do universo e dance a música da sua vida!
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.22 }}
            className="mx-auto max-w-2xl font-body type-body leading-relaxed"
            style={{ color: 'rgba(255,255,255,0.82)' }}
          >
            Descubra como sintonizar uma nova frequência capaz de restabelecer plenitude e equilíbrio em todas as áreas da sua vida.
          </motion.p>
        </div>
      </section>

      <section className="px-4 sm:px-6 py-14 md:py-20" style={{ background: CREAM, color: INK_DARK }}>
        <div className="mx-auto max-w-3xl">
          <h2 className="font-display type-subtitle text-center mb-8" style={{ color: WINE }}>
            Relato após receber os 3 atendimentos à distância da Cura Quântica Frequencial
          </h2>
          <div className="flex flex-col gap-5">
            {SILVIA_AFTER.map((img) => (
              <PrintCard key={img.src} src={img.src} alt={img.alt} />
            ))}
          </div>
        </div>
      </section>

      <section className="px-4 sm:px-6 py-14 md:py-20" style={{ background: CREAM_SOFT, color: INK_DARK }}>
        <div className="mx-auto max-w-3xl">
          <h2 className="font-display type-subtitle text-center mb-8" style={{ color: WINE }}>
            Relato após 20 dias dos 3 atendimentos da Cura Quântica Frequencial
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {SILVIA_20_DAYS.map((img) => (
              <PrintCard key={img.src} src={img.src} alt={img.alt} />
            ))}
          </div>
        </div>
      </section>

      <section
        className="px-4 sm:px-6 py-14 md:py-20"
        style={{ background: `linear-gradient(180deg, ${WINE} 0%, ${WINE_DEEP} 100%)` }}
      >
        <div className="mx-auto max-w-3xl">
          <h2 className="font-display type-subtitle text-center mb-8 text-white">
            Pra quem é a Cura Quântica Frequencial?
          </h2>
          <ul className="space-y-4">
            {FOR_WHOM.map((item) => (
              <li key={item} className="flex items-start gap-3">
                <CheckIcon />
                <p className="font-body type-body leading-relaxed" style={{ color: 'rgba(255,255,255,0.86)' }}>
                  {item}
                </p>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="px-4 sm:px-6 py-14 md:py-20" style={{ background: WINE_DEEP }}>
        <div className="mx-auto max-w-4xl">
          <h2 className="font-display type-subtitle text-center mb-10 text-white">
            Sobre a Cura Quântica Frequencial
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 mb-4 md:mb-5">
            {ABOUT_CARDS.map((card) => (
              <article
                key={card.title}
                className="rounded-sm p-6 sm:p-7"
                style={{
                  background: 'linear-gradient(135deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.03) 100%)',
                  border: '1px solid rgba(255,255,255,0.12)',
                }}
              >
                <h3 className="font-display type-section mb-3" style={{ color: LILAC }}>
                  {card.title}
                </h3>
                <p className="font-body type-body leading-relaxed" style={{ color: 'rgba(255,255,255,0.84)' }}>
                  {card.text}
                </p>
              </article>
            ))}
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
            {ABOUT_EXTRA.map((card) => (
              <article
                key={card.title}
                className="rounded-sm p-6 sm:p-7"
                style={{
                  background: 'linear-gradient(135deg, rgba(185,163,217,0.12) 0%, rgba(255,255,255,0.03) 100%)',
                  border: `1px solid ${LILAC}33`,
                }}
              >
                <h3 className="font-display type-section mb-3" style={{ color: LILAC }}>
                  {card.title}
                </h3>
                <p className="font-body type-body leading-relaxed" style={{ color: 'rgba(255,255,255,0.84)' }}>
                  {card.text}
                </p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="px-4 sm:px-6 py-14 md:py-20" style={{ background: '#efe6d8', color: INK_DARK }}>
        <div className="mx-auto max-w-2xl text-center">
          <div className="mb-7 flex justify-center">
            <div className="relative">
              <div
                className="absolute -inset-6 rounded-full pointer-events-none"
                style={{ background: `radial-gradient(closest-side, ${WINE}22, transparent 72%)` }}
              />
              <div
                className="relative h-36 w-36 overflow-hidden rounded-full sm:h-44 sm:w-44"
                style={{
                  border: `2px solid ${WINE}55`,
                  boxShadow: `0 0 32px ${WINE}22`,
                }}
              >
                <img
                  src={PHOTO_SRC}
                  alt="Mônica Maria — Terapeuta Vibracional"
                  className="h-full w-full object-cover object-top"
                />
              </div>
            </div>
          </div>
          <p className="font-display type-subtitle mb-1" style={{ color: WINE }}>
            Olá!
          </p>
          <h2 className="font-display type-hero mb-6" style={{ color: WINE }}>
            Aqui é Mônica Maria
          </h2>
          <p className="font-body type-body leading-relaxed mb-5" style={{ color: INK_MUTED }}>
            Sou terapeuta vibracional e meu trabalho é te ajudar a identificar o que está te prendendo e elevar sua vibração para que você crie a vida que merece.
          </p>
          <p className="font-body type-body leading-relaxed" style={{ color: INK_MUTED }}>
            Atuo com a ferramenta da Cura Quântica Frequencial que age na raiz dos bloqueios, não nos sintomas. Porque quando você restaura seu equilíbrio interior, tudo na sua vida começa a se mover.
          </p>
        </div>
      </section>

      <section className="px-4 sm:px-6 py-14 md:py-20" style={{ background: CREAM, color: INK_DARK }}>
        <div className="mx-auto max-w-3xl">
          <h2 className="font-display type-subtitle text-center mb-8" style={{ color: WINE }}>
            Relatos de atendimentos à distância da Cura Quântica Frequencial
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {OTHER_REPORTS.map((img) => (
              <PrintCard key={img.src} src={img.src} alt={img.alt} />
            ))}
          </div>
        </div>
      </section>

      <section
        className="px-4 sm:px-6 py-16 md:py-20"
        style={{ background: `linear-gradient(180deg, ${WINE} 0%, ${WINE_DEEP} 100%)` }}
      >
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="font-display type-subtitle mb-6 text-white">Agende seu atendimento</h2>
          <p className="font-display mb-3 text-white" style={{ fontSize: 'clamp(1.8rem, 4vw, 2.4rem)' }}>
            <span className="numerals">R$ 360,00</span> por atendimento
          </p>
          <p className="font-body type-body leading-relaxed mb-3" style={{ color: 'rgba(255,255,255,0.84)' }}>
            Você pode fazer 1 atendimento ou os 3, a escolha é sua.
          </p>
          <p className="font-body type-body leading-relaxed mb-8" style={{ color: 'rgba(255,255,255,0.84)' }}>
            Recomendamos a experiência completa de 3 atendimentos em dias consecutivos ou alternados.
          </p>
          <a
            href={WA_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex min-h-[64px] w-full items-center justify-center rounded-lg px-10 py-5 font-body text-xl sm:text-2xl font-bold tracking-[0.08em] uppercase transition-all duration-300 hover:brightness-110 active:scale-[0.98]"
            style={{
              background: '#00C853',
              color: '#ffffff',
              border: 'none',
              boxShadow: '0 12px 32px rgba(0,200,83,0.35)',
            }}
          >
            Fale comigo agora
          </a>
        </div>
      </section>

      <section className="px-4 sm:px-6 py-14 md:py-20" style={{ background: WINE_DEEP }}>
        <div className="mx-auto max-w-2xl">
          <h2 className="font-display type-subtitle text-center mb-8 text-white">Perguntas Frequentes</h2>
          <div className="flex flex-col gap-2">
            {FAQ_ITEMS.map((item, i) => {
              const isOpen = openFaq === i
              return (
                <div
                  key={item.q}
                  className="overflow-hidden rounded-sm"
                  style={{
                    background: isOpen ? 'rgba(255,255,255,0.08)' : 'rgba(255,255,255,0.04)',
                    border: `1px solid ${isOpen ? 'rgba(185,163,217,0.35)' : 'rgba(255,255,255,0.1)'}`,
                  }}
                >
                  <button
                    type="button"
                    onClick={() => setOpenFaq((prev) => (prev === i ? null : i))}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left sm:px-6 sm:py-5 focus-visible:outline-none"
                  >
                    <span className="font-body type-body font-medium leading-snug text-white">{item.q}</span>
                    <span
                      className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full"
                      style={{
                        background: isOpen ? 'rgba(185,163,217,0.2)' : 'rgba(255,255,255,0.06)',
                        border: '1px solid rgba(255,255,255,0.16)',
                      }}
                      aria-hidden="true"
                    >
                      <motion.svg
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke={isOpen ? LILAC : 'rgba(255,255,255,0.7)'}
                        strokeWidth={2}
                        className="h-3.5 w-3.5"
                        animate={{ rotate: isOpen ? 180 : 0 }}
                        transition={{ duration: 0.3 }}
                      >
                        <path d="M6 9l6 6 6-6" />
                      </motion.svg>
                    </span>
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen ? (
                      <motion.div
                        key="answer"
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: 'auto', opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3 }}
                        style={{ overflow: 'hidden' }}
                      >
                        <div className="px-5 pb-5 sm:px-6 sm:pb-6" style={{ borderTop: '1px solid rgba(255,255,255,0.08)' }}>
                          <p className="font-body type-body pt-4 leading-relaxed" style={{ color: 'rgba(255,255,255,0.78)' }}>
                            {item.a}
                          </p>
                        </div>
                      </motion.div>
                    ) : null}
                  </AnimatePresence>
                </div>
              )
            })}
          </div>
        </div>
      </section>

      <footer
        className="w-full px-4 py-10 text-center border-t"
        style={{ background: WINE_DEEP, borderColor: 'rgba(255,255,255,0.08)' }}
      >
        <p className="font-display italic text-[16px] mb-2" style={{ color: 'rgba(247,239,232,0.72)' }}>
          Com amor e presença, Mônica Maria
        </p>
        <p className="text-[11px] tracking-[0.3em] uppercase font-body opacity-50" style={{ color: LILAC }}>
          Reacenda Luz
        </p>
      </footer>
    </div>
  )
}
